module.exports = __webpack_public_path__ + "img/403.1de76a9.svg";